module.exports = __webpack_public_path__ + "img/namsan_gallery5.136da7a2.jpg";